import { Component } from '@angular/core';
import { CrashMessageService } from '../../services/crash-message.service';
import { Subject } from 'rxjs';

@Component({
     selector: 'app-crash-component',
     templateUrl: 'crash.component.html',
     styleUrls: ['./crash.component.scss'],
})
export class CrashComponent {
     message$: Subject<string>;
     constructor(private crashMessage: CrashMessageService) {
          this.message$ = crashMessage.message$;
     }
}
